import React from 'react';
import { Link } from 'react-router';
import { contactHeading } from './merge';

function formatTime(iso) {
    if (!iso) return '';
    const date = new Date(iso);
    return isNaN(date.getTime()) ? '' : date.toLocaleString('en-US', {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    });
}

/**
 * The send while it runs and once it is done.
 *
 * `run.sent + run.skipped + run.failed` is what the server has actually
 * decided so far, so the bar moves on recorded outcomes rather than a guess.
 */
export default function RunPanel({ run, total, backLink, backLabel, noun = 'owner' }) {
    const settled = (run.sent || 0) + (run.skipped || 0) + (run.failed || 0);
    const finished = run.status !== 'running';

    if (!finished) {
        return (
            <div className="mm-card mm-run">
                <div className="mm-run__pad">
                    <div className="mm-run__head">
                        <div className="mm-panel__title">Sending emails</div>
                        <span className="mm-pill mm-pill--info">
                            <span className="mm-pill__dot"/>Running in background
                        </span>
                    </div>
                    <div className="mm-progress">
                        <div style={{ width: Math.round((settled / Math.max(1, total)) * 100) + '%' }}/>
                    </div>
                    <div className="mm-run__line">
                        <div>Sent {run.sent || 0} of {total}</div>
                    </div>
                    <div className="mm-run__note">
                        You can leave this page — sending continues in the background.
                    </div>
                </div>
            </div>
        );
    }

    const failures = run.failures || [];

    return (
        <div className="mm-card mm-run">
            <div style={{ padding: '20px 24px 0' }}>
                <div className="mm-run__head">
                    <div className="mm-panel__title">
                        {run.status === 'failed' ? 'Send failed' : 'Send complete'}
                    </div>
                    <div className="mm-run__meta">
                        {formatTime(run.finished_at)}
                        {run.started_by ? ' · sent by ' + run.started_by : ''}
                        {run.subject ? ' · subject "' + run.subject + '"' : ''}
                    </div>
                </div>

                {run.error ? <div className="mm-alert--danger" style={{ margin: '13px 0 0' }}>{run.error}</div> : null}

                <div className="mm-run__pills">
                    <span className="mm-pill mm-pill--ok"><span className="mm-pill__dot"/>{run.sent || 0} delivered to send queue</span>
                    {run.failed > 0
                        ? <span className="mm-pill mm-pill--fail"><span className="mm-pill__dot"/>{run.failed} failed</span>
                        : null}
                    {run.skipped > 0 ? <span className="mm-pill">{run.skipped} skipped</span> : null}
                </div>
            </div>

            {failures.length > 0 ? (
                <React.Fragment>
                    <div style={{ marginTop: 16, padding: '0 24px 4px' }}>
                        <div className="mm-eyebrow">Failed — {failures.length}</div>
                    </div>
                    <div className="mm-fail-row mm-fail-row--header">
                        <div>{contactHeading(noun)}</div><div>Email</div><div>Reason</div>
                    </div>
                    {failures.map((failure, index) => (
                        <div className="mm-fail-row" key={index}>
                            <div>{failure.name}</div>
                            <div className="mm-row__muted">{failure.email}</div>
                            <div className="mm-fail-row__reason">{failure.reason}</div>
                        </div>
                    ))}
                </React.Fragment>
            ) : null}

            <div className="mm-run__actions">
                <div className="mm-spacer"/>
                <Link to={backLink} className="mm-back">{backLabel}</Link>
            </div>
        </div>
    );
}
